export default __webpack_public_path__ + "static/media/nav-communitiy.79a75f86.svg";